import React, { useState, useEffect } from 'react';
import { Quote, Plus } from 'lucide-react';
import api from '../services/api';
import AddReviewModal from './AddReviewModal';

const staticReviews = [
    // {
    //     id: 1,
    //     text: "The geniuses who listen, understand, and craft captivating visuals - an agency that truly understands our needs.",
    //     name: "Gabrielle Williams",
    //     role: "CEO and Co-founder of ABC Company",
    //     image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    // },
    // // ... keep a few static reviews as fallback or mixer if needed, 
    // // but for now let's just use them if API returns empty to avoid empty space
    // {
    //     id: 2,
    //     text: "Exceeded our expectations with innovative designs that brought our vision to life - a truly remarkable creative agency.",
    //     name: "Samantha Johnson",
    //     role: "CEO and Co-founder of ABC Company",
    //     image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    // },
    // {
    //     id: 3,
    //     text: "Their ability to capture our brand essence in every project is unparalleled - an invaluable creative collaborator.",
    //     name: "Isabella Rodriguez",
    //     role: "CEO and Co-founder of ABC Company",
    //     image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    // },
    // {
    //     id: 4,
    //     text: "Creative geniuses who listen, understand, and deliver captivating visuals - an agency that truly understands our vision.",
    //     name: "Gabrielle Williams",
    //     role: "CEO and Co-founder of ABC Company",
    //     image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    // },
    // {
    //     id: 5,
    //     text: "Their team's artistic flair and strategic approach resulted in remarkable campaigns - a reliable creative partner.",
    //     name: "John Peter",
    //     role: "CEO and Co-founder of ABC Company",
    //     image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    // }
];

const ReviewCard = ({ review }) => (
    <div className="w-[260px] md:w-[320px] h-full flex flex-col flex-shrink-0 bg-brand-card p-5 md:p-6 rounded-2xl mx-2 md:mx-3 transition-transform hover:-translate-y-1 duration-300 border border-gray-800 hover:border-brand-gold shadow-lg group">
        <Quote className="w-6 h-6 md:w-8 md:h-8 text-brand-gold mb-3 md:mb-4 opacity-80" />
        <p className="text-brand-textLight text-sm md:text-base leading-relaxed mb-4 md:mb-6 font-medium flex-grow">
            {review.text}
        </p>
        <div className="mt-auto flex items-center gap-3">
            <img
                src={review.image}
                alt={review.name}
                className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover ring-2 ring-gray-800 group-hover:ring-brand-gold transition-all"
            />
            <div>
                <h4 className="font-bold text-brand-textLight text-xs md:text-sm">{review.name}</h4>
                <p className="text-brand-textMuted text-[10px] md:text-xs">{review.role}</p>
            </div>
        </div>
    </div>
);

const ReviewsSection = () => {
    const [reviews, setReviews] = useState(staticReviews);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const response = await api.get('/reviews');
                // api interceptor returns response.data (the body)
                // body structure: { success: true, count: N, data: [...] }
                if (response.success && response.data && response.data.length > 0) {
                    const dbReviews = response.data;

                    if (dbReviews.length < 5) {
                        setReviews([...dbReviews, ...staticReviews.slice(0, 5 - dbReviews.length)]);
                    } else {
                        setReviews(dbReviews);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch reviews:', error);
                // Fallback to static reviews (already set)
            }
        };

        fetchReviews();
    }, []);

    const handleReviewAdded = (newReview) => {
        // newReview is the review object passed from AddReviewModal
        setReviews(prev => [newReview, ...prev]);
    };

    return (
        <section className="py-12 md:py-24 bg-brand-bg overflow-hidden relative">
            <div className="max-w-7xl mx-auto px-4 md:px-6 mb-10 md:mb-16 text-center relative z-10">
                <h2 className="text-2xl md:text-3xl font-bold text-brand-textMuted">
                    Words of Praise from Others
                    <br />
                    about Our Presence.
                </h2>

                <button
                    onClick={() => setIsModalOpen(true)}
                    className="mt-8 inline-flex items-center gap-2 px-6 py-2.5 bg-brand-gold hover:bg-brand-goldHover text-black rounded-full font-medium transition-all transform hover:scale-105 shadow-lg shadow-brand-gold/20 text-sm md:text-base"
                >
                    <Plus className="w-4 h-4 md:w-5 md:h-5" />
                    Add Review
                </button>
            </div>

            <div className="relative">
                {/* Gradient overlays for smooth fade edge */}
                <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

                {/* Top Row - Scrolling Right */}
                <div className="flex mb-4 md:mb-8 relative group">
                    <div
                        className="flex animate-scroll-right group-hover:pause"
                        style={{ animationDuration: `${Math.max(reviews.length * 8, 40)}s` }}
                    >
                        {/* Double the items for seamless loop */}
                        {[...reviews, ...reviews].map((review, idx) => (
                            <ReviewCard key={`${review._id || review.id}-top-${idx}`} review={review} />
                        ))}
                    </div>
                    <div
                        className="flex animate-scroll-right group-hover:pause" aria-hidden="true"
                        style={{ animationDuration: `${Math.max(reviews.length * 8, 40)}s` }}
                    >
                        {[...reviews, ...reviews].map((review, idx) => (
                            <ReviewCard key={`${review._id || review.id}-top-duplicate-${idx}`} review={review} />
                        ))}
                    </div>
                </div>

                {/* Bottom Row - Scrolling Left */}
                <div className="flex relative group">
                    <div
                        className="flex animate-scroll-left group-hover:pause"
                        style={{ animationDuration: `${Math.max(reviews.length * 8, 40)}s` }}
                    >
                        {[...reviews, ...reviews].reverse().map((review, idx) => (
                            <ReviewCard key={`${review._id || review.id}-bottom-${idx}`} review={review} />
                        ))}
                    </div>
                    <div
                        className="flex animate-scroll-left group-hover:pause" aria-hidden="true"
                        style={{ animationDuration: `${Math.max(reviews.length * 8, 40)}s` }}
                    >
                        {[...reviews, ...reviews].reverse().map((review, idx) => (
                            <ReviewCard key={`${review._id || review.id}-bottom-duplicate-${idx}`} review={review} />
                        ))}
                    </div>
                </div>
            </div>

            <AddReviewModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onReviewAdded={handleReviewAdded}
            />
        </section>
    );
};

export default ReviewsSection;
